import { setPageDetails } from '../analytics';
var BASE = 'account>track business spend';
var MAML = 'maml:track business spend';
var MY_ACCOUNT = 'my account';
/**
 * Page analtyics for business tools
 */
export var setBusinessToolsPageAnalytics = function () {
    var purchaseHistoryPageData = {
        pageInfo: {
            pageName: BASE,
            pageType: MAML,
        },
        category: {
            primaryCategory: MY_ACCOUNT,
            subCategory1: BASE,
            subCategory2: BASE,
        },
    };
    setPageDetails(purchaseHistoryPageData);
};
